"use client";

import { Loader2 } from "lucide-react";

interface PageLoaderProps {
  message?: string;
  className?: string;
}

export default function PageLoader({ message = "Loading...", className = "" }: PageLoaderProps) {
  return (
    <div
      className={`min-h-screen flex flex-col items-center justify-center gap-4 ${className}`}
      role="status"
      aria-live="polite"
    >
      <Loader2 className="w-8 h-8 animate-spin text-indigo-500" strokeWidth={2} aria-hidden />
      <p className="text-sm text-gray-600 dark:text-slate-400">{message}</p>
    </div>
  );
}
